import type { Maybe } from '@adornis/base/utilTypes.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@chancenwerk/design/components/cr-flex.js';
import '@chancenwerk/design/components/fonts.js';
import { Foundation } from '@chancenwerk/master-data-management/partner/entities/Foundation.js';
import { Partner } from '@chancenwerk/master-data-management/partner/entities/Partner.js';
import { PartnerPublicInformationAPI } from '@chancenwerk/public-access/api/PartnerPublicInformationAPI.js';
import { html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { map } from 'rxjs';
import { Adresse } from '../../db/adresse.js';
import { ChromiumDropdownSearchSelection } from '../design/components/cr-dropdown-search-selection.js';

@customElement('chancen-component-foundation-picker')
export class ChancenComponentFoundationPicker extends ChromiumDropdownSearchSelection<Partner, Partner> {
  @state() protected _foundations = new RXController(
    this,
    PartnerPublicInformationAPI.getAllFoundation()({
      name: 1,
      kuerzel: 1,
      address: Adresse.allFields,
    }),
    obs => obs.pipe(map(fs => fs.filter(f => f._id))),
  );

  override renderItem = (foundation: Partner, index: number, value: Maybe<Partner>) => {
    return html`
      <cr-flex space="xs" padding="sm">
        <cr-text> ${foundation.name !== '' ? foundation.name : foundation.kuerzel || 'NO_NAME'} </cr-text>
        ${foundation instanceof Foundation && foundation.address?.zipCity?.city
          ? html`
              <cr-text ${css({ color: this.colors.neutral.shade(800) })}> ${foundation.address.zipCity.city} </cr-text>
            `
          : nothing}
      </cr-flex>
    `;
  };
  override renderString = (foundation: Maybe<Partner>) => foundation?.name ?? '';
  override search = (search: Maybe<string>) => {
    return (
      this._foundations.value?.filter(foundation =>
        search
          ? foundation.name?.toLowerCase().includes(search.toLowerCase()) ||
            foundation.kuerzel?.toLowerCase().includes(search.toLowerCase())
          : true,
      ) ??
      this._foundations.value ??
      []
    );
  };
}
